// Import polyfills before any other code
// This must be the first import to ensure Node.js compatibility
import './polyfills';

import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
// Import fallback theme styles to ensure application is usable even if theme.json fails
import "./lib/theme-fallback.css";
// Removed loader.ts imports - using app.js instead to avoid conflicts
import { dynamicActivate } from "./lib/i18n";
import './lib/i18n'; // Import i18n configuration

// Initialize app with performance optimizations
const initializeApp = async () => {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    // Silent failure - this is a critical error but logging won't help the user
    return;
  }

  // Initialize i18n before creating React root
  try {
    // Check for language parameter in URL
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    
    // Use language from URL param if valid, otherwise fallback to localStorage or default
    let locale = 'en';
    
    if (langParam && ['en', 'ar', 'zh', 'ja', 'ru', 'de', 'fr', 'es', 'hi', 'tr', 'sv'].includes(langParam)) {
      locale = langParam;
    } else {
      locale = localStorage.getItem('locale') || 'en';
    }
    
    await dynamicActivate(locale as any);
  } catch (error) {
    // Silent error handling - i18n initialization errors should not break the app
  }

  // Create React root
  const root = createRoot(rootElement);

  // Render app immediately
  root.render(<App />);
};

// Simple initialization on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  initializeApp();
});

// Resource cleanup
window.addEventListener('beforeunload', () => {
  try {
    const blobUrls = Array.from(document.querySelectorAll('script[src^="blob:"]')) as HTMLScriptElement[];
    blobUrls.forEach(script => URL.revokeObjectURL(script.src));

    // Clear any runtime errors from storage
    localStorage.removeItem('runtimeErrors');
    sessionStorage.removeItem('runtimeErrors');
  } catch (error) {
    // Silent error handling - cleanup errors should not affect user experience
  }
});